// src/components/SensorDetailForm.js
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Box, Button, FormControl, FormLabel, Select, Textarea, useToast, Heading, Text, Checkbox } from '@chakra-ui/react';
import { FaArrowLeft } from 'react-icons/fa';
import * as amplitude from '@amplitude/analytics-browser';
import { useNavigate, useParams } from 'react-router-dom';
import { saveSensorDetails } from '../utils/firebase.utils';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const SensorDetailForm = () => {
  const { register, handleSubmit, reset, control } = useForm();
  const toast = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(window.location.search);

  const onSubmit = async (data) => {
    try {
      let dataMerge = { ...data, userData: JSON.parse(localStorage.getItem('userData') || '{}'), sensor: queryParams.get('sensor') };
      await saveSensorDetails(dataMerge);
      amplitude.track('Sensor Details Submitted', dataMerge);
      reset();
      navigate('/schedule-meeting');
    } catch (error) {
      console.error("Error saving sensor details:", error);
      toast({
        title: t('errorOccurredTitle'),
        description: t('errorOccurredDesc'),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box marginX="10%" marginY="5%">
      <Box my={4}>
        <Button leftIcon={<FaArrowLeft />} colorScheme="blue" variant="ghost" onClick={() => navigate(-1)}>
          {t('backButton')}
        </Button>
        <Heading as="h3" size="lg" mb={4}>
          {t('sensorDetailFormTitle')}
        </Heading>
        <Heading as="h2" size="md" mb={4}>
          "{queryParams.get('sensor')}"
        </Heading>
        <Text mb={8}>
          {t('sensorDetailFormSubtitle')}
        </Text>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl isRequired mt={4}>
            <FormLabel htmlFor="phone">{t('phoneLabel')}</FormLabel>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <PhoneInput
                  country={'us'}
                  value={field.value}
                  onChange={field.onChange}
                  inputProps={{
                    name: 'phone',
                    required: true,
                    autoFocus: true
                  }}
                />
              )}
            />
          </FormControl>

          <FormControl mt={4}>
            <Checkbox {...register('contactAllowed')}>{t('contactAllowedLabel')}</Checkbox>
          </FormControl>

          <FormControl isRequired mt={6}>
            <FormLabel htmlFor="problem">{t('problemLabel')}</FormLabel>
            <Textarea id="problem" placeholder={t('problemPlaceholder')} {...register('problem')} />
          </FormControl>

          <FormControl isRequired mt={4}>
            <FormLabel htmlFor="numSensors">{t('numSensorsLabel')}</FormLabel>
            <Select id="numSensors" placeholder={t('selectOption')} {...register('numSensors')}>
              {["0-10", "10-50", "50-100", "100-500", "500-1000", "1000-2000", "3000+"].map(option => (
                <option key={option} value={option}>{t(option)}</option>
              ))}
            </Select>
          </FormControl>

          <FormControl mt={4}>
            <FormLabel htmlFor="additionalComments">{t('additionalCommentsLabel')}</FormLabel>
            <Textarea id="additionalComments" placeholder={t('additionalCommentsPlaceholder')} {...register('additionalComments')} />
          </FormControl>

          <Button mt={4} colorScheme="blue" type="submit">{t('next')}</Button>
        </form>
      </Box>
    </Box>
  );
};

export default SensorDetailForm;